import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        links: {
            android: "http://play.google.com/store/apps/details?id=ca.davidhooey.hymnbooks",
            ios: "https://itunes.apple.com/us/app/hymnbooks/id574873272?mt=8&uo=4",
            macos: "https://apps.apple.com/ca/app/hymnbooks/id574873272",
            windows: "https://d3nigj4sp1xlsv.cloudfront.net/Windows/Hymnbooks-1.0.0.msi"
        },
    },

    getters: {
        getLinks: (state) => {
            return state.links
        }
    }
})
